import React from 'react';
import { ConfirmationPage } from './pages/ConfirmationPage';
export function App() {
  return <ConfirmationPage data-id="element-0" />;
}